import Widget from '@/components/Widget';

const WidgetEmbedPage = () => {
  return (
    <div style={{ height: 'calc(100vh - 32px)' }}>
      <Widget />
    </div>
  );
};

export default WidgetEmbedPage;
